export const roleAndPermissionEnum = {
  dashboard: {
    moduleKey: "dashboard",
    all: "dashboard:*",
    view: "dashboard:view",
    renewContract: "dashboard:renewContract",
    switchB2C: "dashboard:switchtoB2C",
  },
  company: {
    moduleKey: "company",
    all: "company:*",
    view: "company:view",
    add: "company:add",
    edit: "company:edit",
    editStatus: "company:status",
  },
  employee: {
    moduleKey: "employee",
    all: "employee:*",
    view: "employee:view",
    add: "employee:add",
    edit: "employee:edit",
    editStatus: "employee:status",
  },
  reservation: {
    moduleKey: "reservation",
    all: "reservation:*",
    view: "reservation:view",
    add: "reservation:add",
    edit: "reservation:edit",
    cancel: "reservation:cancel",
  },

  compliance: {
    moduleKey: "compliance",
    all: "compliance:*",
    complianceSubVendorView: "compliance:subVendor:view",
    complianceDriverView: "compliance:driver:view",
    complianceVehicleView: "compliance:vehicle:view",
    complianceVehicleApprove: "compliance:vehicle:approveReject",
    complianceDriverApprove: "compliance:driver:approveReject",
    complianceSubVendorApprove: "compliance:subVendor:approveReject",
  },

  reports: {
    moduleKey: "reports",
    all: "reports:*",
    view: "reports:view",
    download: "reports:download",
    subModules: {
      booking: {
        moduleKey: "booking",
        view: "booking:view",
        download: "booking:download",
      },
      revenue: {
        moduleKey: "revenue",
        view: "revenue:view",
        download: "revenue:download",
      },
    },
  },

  operation: {
    moduleKey: "operation",
    allRides: {
      moduleKey: "allRides",
      allRidesView: "allRides:view",
      allRidesCancel: "allRides:cancel",
      allRidesDispatch: "allRides:generateInvoice",
      allRidesAllot: "allRides:allot",
    },
    allotTrip: {
      moduleKey: "allotTrip",
      allotTripView: "allotTrip:view",
      allotTripCancel: "allotTrip:cancel",
      allotTripDispatch: "allotTrip:dispatch",
      allotTripReallot: "allotTrip:reallot",
    },
    allotVehicle: {
      moduleKey: "allotVehicle",
      allotVehicleView: "allotVehicle:view",
      allotVehicleAssign: "allotVehicle:assign",
    },
    allotDriver: {
      moduleKey: "allotDriver",
      allotDriverView: "allotDriver:view",
      allotDriverAssign: "allotDriver:assign",
    },
    billing: {
      moduleKey: "billing",
      billingView: "billing:view",
      billingGenerate: "billing:generate",
    },
    dispatch: {
      moduleKey: "dispatch",
      dispatchView: "dispatch:view",
      dispatchCancel: "dispatch:cancel",
    },
  },

  subvendor: {
    moduleKey: "subVendor",
    all: "subVendor:*",
    subVendorView: "subVendor:view",
    subVendorActivate: "subVendor:activate",
    subVendorEdit: "subVendor:edit",
    subVendorAdd: "subVendor:add",
    subVendorBlock: "subVendor:block",
    activateDriver: "subVendor:activateDriver",
    blockVehicel: "subVendor:blockVehicle",
    editVehicle: "subVendor:editVehicle",
    addVehicle: "subVendor:addVehicle",
    blockDriver: "subVendor:blockDriver",
    editDriver: "subVendor:editDriver",
    addDriver: "subVendor:addDriver",
  },

  driver: {
    moduleKey: "drivers",
    all: "driver:*",
    driverView: "driver:view",
    driverActivate: "driver:activate",
    driverEdit: "driver:edit",
    driverAdd: "driver:add",
    driverBlock: "driver:block",
  },

  vehicle: {
    moduleKey: "vehicle",
    all: "vehicle:*",
    vehicleView: "vehicles:view",
    vehicleEdit: "vehicles:edit",
    vehicleAdd: "vehicles:add",
    vehicleBlock: "vehicles:block",
  },

  customer: {
    moduleKey: "customer",
    all: "customer:*",
    view: "customer:view",
    block: "customer:block",
  },

  settlement: {
    moduleKey: "settlement",
    all: "settlement:*",
    view: "settlement:view",
    add: "settlement:newPayment",
  },
  regionalmanager: {
    moduleKey: "regionalmanager",
    all: "regionalManager:*",
    view: "regionalManager:view",
    add: "regionalManager:add",
  },
  citymanager: {
    moduleKey: "cityManager",
    all: "cityManager:*",
    view: "cityManager:view",
    add: "cityManager:add",
  },

  configuration: {
    moduleKey: "configuration",
    all: "configuration:*",
    subModules: {
      feedback: {
        moduleKey: "configFeedback",
        all: "configFeedback:*",
        view: "configFeedback:view",
        edit: "configFeedback:edit",
        add: "configFeedback:add",
      },
      compliance: {
        moduleKey: "configCompliance",
        all: "configCompliance:*",
        view: "configCompliance:view",
        edit: "configCompliance:edit",
        add: "configCompliance:add",
      },
      vehicleCategory: {
        moduleKey: "vehicleCategory",
        all: "vehicleCategory:*",
        view: "vehicleCategory:view",
        edit: "vehicleCategory:edit",
        add: "vehicleCategory:add",
      },
      faq: {
        moduleKey: "faq",
        all: "faq:*",
        view: "faq:view",
        edit: "faq:edit",
        add: "faq:add",
      },
      coupon: {
        moduleKey: "coupon",
        all: "coupon:*",
        view: "coupon:view",
        edit: "coupon:edit",
        add: "coupon:add",
        delete: "coupon:delete",
      },
    },
  },
  sealSign: {
    moduleKey: "seal-sign",
    all: "seal-sign:*",
    view: "seal-sign:view",
    update: "seal-sign:update",
  },

  audittrail: {
    moduleKey: "audittrail",
    all: "audittrail:*",
    view: "audittrail:view",
  },
};
